<template>
  <pr-box :title="titleBox">

    <div slot="buttons-header">
      <v-btn icon :to="{ name: 'zoho-report-credential-form', params: { id: 'new' }}"
             v-if="!widget" v-show="!resources || resources.length === 0">
        <v-icon color="white">add</v-icon>
      </v-btn>
    </div>

    <div>

      <v-data-table
        :headers="headers"
        :items="resources"
        :total-items="totalResources"
        :pagination.sync="orderSync"
        :no-data-text="noDataAvailable"
        :hide-actions="true"
        class="elevation-0">

        <template slot="items" slot-scope="props">

          <td>
            {{ props.item.client_id }}
          </td>
          <td>
            {{ props.item.client_secret }}
          </td>
          <td>
            {{ props.item.refresh_token }}
          </td>
          <td class="text-xs-center">

            <v-btn color="primary" flat icon @click="goToForm(props.item.id)">
              <v-icon>mode_edit</v-icon>
            </v-btn>

            <v-btn flat icon color="error" @click="destroy(props.item.id)">
              <v-icon>delete</v-icon>
            </v-btn>

          </td>
        </template>
      </v-data-table>
      <pr-pagination :paginator="paginator"></pr-pagination>
    </div>
  </pr-box>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import ZohoReportCredentialService from '@/features/zoho-report-credential/ZohoCredentialService';

export default {
  name: 'zoho-report-credential-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('attributes.zoho.client_id'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.zoho.client_secret'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.zoho.refresh_token'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('views.fields.actions'),
          sortable: false,
          align: 'right',
        },
      ],
    };
  },
  methods: {
    initCrud() {
      this.serviceType = ZohoReportCredentialService;
      this.routerName = 'zoho-report-credential';
      this.options.skipPagination = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/zoho-report-credential/ZohoReportCredentialList.vue